

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;

        @Prop()
        public Pedido: Pedido;

        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Pedido.Cliente; }
        public get Envio() { return this.Pedido.Envio; }

        Abrir( x: Item )
        {

        }

        AbrirPublicacion( x: string )
        {
            if ( x )
                window.open( x );
        }
    }
